/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */

import type { CardProps, ThumbnailProps } from '../types'
import { UnifiedCard } from '../unified-card'

export interface ResourceCardProps {
	heading: string
	date?: string
	category: string
	link: string
	productBadges?: CardProps['productBadges']
	thumbnail: ThumbnailProps
	isExternal?: CardProps['isExternal']
}

export function ResourceCard({
	heading,
	date,
	category,
	link,
	productBadges,
	thumbnail,
	isExternal,
}: ResourceCardProps) {
	const meta: string[] = date ? [date, category] : [category]

	return (
		<UnifiedCard
			heading={heading}
			link={link}
			meta={meta}
			productBadges={productBadges}
			thumbnail={thumbnail}
			isExternal={isExternal}
		/>
	)
}
